<template>
    <span :class="badgeClass">
      {{ isActive ? 'Active' : 'Inactive' }}
    </span>
  </template>

  <script setup>
  import { computed } from 'vue';

  const props = defineProps({
    isActive: {
      type: Boolean,
      required: true
    }
  });

  const badgeClass = computed(() => ({
    'badge': true,
    'bg-success': props.isActive,
    'bg-danger': !props.isActive
  }));
  </script>

  <style scoped lang="scss">
  .badge {
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.375rem;
    text-transform: uppercase;

    &.bg-success {
      background-color: #28a745;
      color: white;
    }

    &.bg-danger {
      background-color: #dc3545;
      color: white;
    }
  }
  </style>